module.exports = __webpack_public_path__ + "img/Imagen 6.20a44258.jpg";